import React, { useState } from 'react';
import { Upload, Palette, Eye, Save, Globe, Lock, ChevronDown, Monitor, Smartphone, Check } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const CURRENCIES = [{
  code: 'USD',
  label: 'US Dollar',
  symbol: '$'
}, {
  code: 'CAD',
  label: 'Canadian Dollar',
  symbol: 'C$'
}];
const LOCATIONS = [{
  code: 'US',
  label: 'United States'
}, {
  code: 'CA',
  label: 'Canada'
}];
export function BrandHub() {
  const [primaryColor, setPrimaryColor] = useState('#4F46E5');
  const [secondaryColor, setSecondaryColor] = useState('#0F172A');
  const [brandName, setBrandName] = useState('MyReseller Pro');
  const [currency, setCurrency] = useState('USD');
  const [location, setLocation] = useState('US');
  const [slaText, setSlaText] = useState('This hosting plan guarantees 99.9% uptime and 24/7 priority support...');
  return <div className="space-y-6 max-w-[1600px] mx-auto h-full flex flex-col" data-id="element-1614">
      <div className="flex items-center justify-between bg-white p-6 rounded-lg border border-gray-200 shadow-sm" data-id="element-1615">
        <div data-id="element-1616">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1617">Brand Hub</h1>
          <p className="text-sm text-gray-500 font-medium" data-id="element-1618">
            White-Label Engine: Configure your brand identity and global
            storefront settings.
          </p>
        </div>
        <div className="flex gap-3" data-id="element-1619">
          <button className="px-4 py-2.5 text-sm font-bold text-gray-600 hover:bg-gray-50 rounded-lg transition-colors" data-id="element-1620">
            Discard
          </button>
          <button className="px-6 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-500/20 transition-all flex items-center gap-2" data-id="element-1621">
            <Save size={18} data-id="element-1622" />
            Publish Branding
          </button>
        </div>
      </div>

      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 gap-6 min-h-0" data-id="element-1623">
        {/* Left Column: Control Panel */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm flex flex-col overflow-hidden" data-id="element-1624">
          <div className="flex-1 overflow-y-auto p-8 space-y-8" data-id="element-1625">
            <div className="space-y-6" data-id="element-1626">
              <div className="space-y-2" data-id="element-1627">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1628">
                  Brand Name
                </label>
                <input type="text" value={brandName} onChange={e => setBrandName(e.target.value)} className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus:ring-2 focus:ring-indigo-500/20 outline-none transition-all font-medium" data-id="element-1629" />
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-1630">
                <div className="space-y-2" data-id="element-1631">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1632">
                    Light Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-gray-200 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-gray-50 group" data-id="element-1633">
                    <Upload size={20} className="text-gray-400" data-id="element-1634" />
                    <span className="text-[10px] font-bold text-gray-400" data-id="element-1635">
                      SVG/PNG
                    </span>
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1636">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1637">
                    Dark Mode Logo
                  </label>
                  <div className="border-2 border-dashed border-slate-800 rounded-lg p-6 flex flex-col items-center justify-center gap-2 hover:border-indigo-400 transition-colors cursor-pointer bg-slate-900 group" data-id="element-1638">
                    <Upload size={20} className="text-slate-500" data-id="element-1639" />
                    <span className="text-[10px] font-bold text-slate-500" data-id="element-1640">
                      SVG/PNG
                    </span>
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1641">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1642">
                  Favicon (32x32)
                </label>
                <div className="flex items-center gap-4 p-4 bg-gray-50 border border-gray-200 rounded-lg border-dashed hover:border-indigo-400 cursor-pointer transition-all" data-id="element-1643">
                  <div className="w-8 h-8 bg-white rounded border border-gray-200 flex items-center justify-center" data-id="element-1644">
                    <Globe size={16} className="text-gray-400" data-id="element-1645" />
                  </div>
                  <span className="text-xs font-bold text-gray-400" data-id="element-1646">
                    Upload .ico or .png
                  </span>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-6" data-id="element-1647">
                <div className="space-y-2" data-id="element-1648">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1649">
                    Primary Color
                  </label>
                  <div className="flex gap-2" data-id="element-1650">
                    <input type="color" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="w-10 h-10 rounded-lg cursor-pointer border-none p-0 overflow-hidden" data-id="element-1651" />
                    <input type="text" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="flex-1 px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-xs font-mono font-bold" data-id="element-1652" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-1653">
                  <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1654">
                    Global Currency
                  </label>
                  <div className="relative" data-id="element-1655">
                    <select value={currency} onChange={e => setCurrency(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1656">
                      {CURRENCIES.map(c => <option key={c.code} value={c.code} data-id="element-1657">
                          {c.code} - {c.label}
                        </option>)}
                    </select>
                    <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-1658" />
                  </div>
                </div>
              </div>

              <div className="space-y-2" data-id="element-1659">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1660">
                  Target Region (US & Canada Only)
                </label>
                <div className="relative" data-id="element-1661">
                  <select value={location} onChange={e => setLocation(e.target.value)} className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg appearance-none text-xs font-bold text-slate-900 focus:ring-2 focus:ring-indigo-500/20 outline-none" data-id="element-1662">
                    {LOCATIONS.map(l => <option key={l.code} value={l.code} data-id="element-1663">
                        {l.label}
                      </option>)}
                  </select>
                  <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" size={14} data-id="element-1664" />
                </div>
              </div>
            </div>

            <div className="pt-6 border-t border-gray-100" data-id="element-1665">
              <div className="flex items-center justify-between mb-4" data-id="element-1666">
                <label className="text-xs font-bold text-gray-400 uppercase tracking-wider" data-id="element-1667">
                  SLA Manager
                </label>
                <div className="flex gap-2" data-id="element-1668">
                  {['$35', '$65', '$99'].map(tier => <button key={tier} className="text-[10px] font-bold text-gray-500 bg-gray-100 px-2 py-0.5 rounded uppercase hover:bg-indigo-50 hover:text-indigo-600 transition-all" data-id="element-1669">
                      {tier} Tier
                    </button>)}
                </div>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm" data-id="element-1670">
                <div className="flex border-b border-gray-100 p-2 gap-1 bg-gray-50/50" data-id="element-1671">
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs" data-id="element-1672">
                    B
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs italic" data-id="element-1673">
                    I
                  </button>
                  <button className="w-8 h-8 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 hover:shadow-sm rounded transition-all font-bold text-xs underline" data-id="element-1674">
                    U
                  </button>
                </div>
                <div contentEditable onBlur={e => setSlaText(e.currentTarget.textContent || '')} className="w-full h-32 p-4 text-sm focus:outline-none resize-none font-medium text-slate-600 overflow-y-auto" suppressContentEditableWarning={true} data-id="element-1675">
                  {slaText}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column: Live Preview Frame */}
        <div className="bg-slate-900 rounded-lg border border-slate-800 shadow-2xl overflow-hidden flex flex-col" data-id="element-1676">
          <div className="bg-slate-800/50 px-6 py-4 border-b border-slate-700 flex items-center justify-between" data-id="element-1677">
            <div className="flex items-center gap-3" data-id="element-1678">
              <div className="flex gap-1.5" data-id="element-1679">
                <div className="w-3 h-3 rounded-full bg-red-500/60" data-id="element-1680"></div>
                <div className="w-3 h-3 rounded-full bg-amber-500/60" data-id="element-1681"></div>
                <div className="w-3 h-3 rounded-full bg-emerald-500/60" data-id="element-1682"></div>
              </div>
              <div className="h-4 w-[1px] bg-slate-700 mx-2" data-id="element-1683"></div>
              <div className="flex items-center gap-2" data-id="element-1684">
                <Eye size={14} className="text-slate-400" data-id="element-1685" />
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1686">
                  Live Preview: Customer OS
                </span>
              </div>
            </div>
            <div className="flex gap-2" data-id="element-1687">
              <button className="p-1.5 text-slate-400 hover:text-white transition-colors" data-id="element-1688">
                <Monitor size={16} data-id="element-1689" />
              </button>
              <button className="p-1.5 text-slate-500" data-id="element-1690">
                <Smartphone size={16} data-id="element-1691" />
              </button>
            </div>
          </div>

          <div className="flex-1 bg-gray-50 flex overflow-hidden" data-id="element-1692">
            {/* Mock Sidebar */}
            <div className="w-16 bg-slate-900 flex flex-col items-center py-6 gap-6" data-id="element-1693">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center text-white font-bold text-xl shadow-lg" style={{
              backgroundColor: primaryColor
            }} data-id="element-1694">
                {brandName.charAt(0)}
              </div>
              <div className="space-y-4" data-id="element-1695">
                {[1, 2, 3, 4].map(i => <div key={i} className={`w-8 h-8 rounded-lg ${i === 1 ? 'bg-white/10' : 'bg-transparent'} flex items-center justify-center`} data-id="element-1696">
                    <div className={`w-4 h-4 rounded ${i === 1 ? 'bg-white' : 'bg-slate-700'}`} data-id="element-1697"></div>
                  </div>)}
              </div>
            </div>

            {/* Mock Content */}
            <div className="flex-1 flex flex-col" data-id="element-1698">
              <header className="h-14 bg-white border-b border-gray-200 flex items-center justify-between px-6" data-id="element-1699">
                <div className="text-xs font-bold text-slate-900" data-id="element-1700">
                  {brandName} Portal
                </div>
                <div className="flex gap-3" data-id="element-1701">
                  <div className="w-8 h-8 rounded-full bg-gray-100" data-id="element-1702"></div>
                </div>
              </header>
              <main className="p-6 space-y-6" data-id="element-1703">
                <div className="grid grid-cols-2 gap-4" data-id="element-1704">
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-1705">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-1706"></div>
                    <div className="text-lg font-bold" style={{
                    color: primaryColor
                  }} data-id="element-1707">
                      $2,450.00
                    </div>
                  </div>
                  <div className="h-24 bg-white rounded-lg border border-gray-200 p-4 space-y-3" data-id="element-1708">
                    <div className="w-12 h-2 bg-gray-100 rounded" data-id="element-1709"></div>
                    <div className="text-lg font-bold text-slate-900" data-id="element-1710">
                      12 Active Sites
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4" data-id="element-1711">
                  <div className="flex items-center justify-between" data-id="element-1712">
                    <div className="text-xs font-bold text-slate-900" data-id="element-1713">
                      Service Level Agreement
                    </div>
                    <button className="px-4 py-2 rounded-lg text-white text-[10px] font-bold shadow-lg" style={{
                    backgroundColor: primaryColor
                  }} data-id="element-1714">
                      Accept SLA
                    </button>
                  </div>
                  <p className="text-[10px] text-gray-500 leading-relaxed italic" data-id="element-1715">
                    "{slaText}"
                  </p>
                </div>
              </main>
            </div>
          </div>

          <div className="p-4 bg-slate-800/30 border-t border-slate-700 flex items-center justify-center gap-6" data-id="element-1716">
            <div className="flex items-center gap-2" data-id="element-1717">
              <div className="w-2 h-2 rounded-full bg-emerald-500" data-id="element-1718"></div>
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1719">
                System Online
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1720">
              <Check size={12} className="text-indigo-400" data-id="element-1721" />
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-1722">
                SSL Secure
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}